import React from 'react';
import { useStepProgress, Step, StepProgressBar } from 'react-stepz';
import PropTypes from 'prop-types';
import { setItemStepz } from 'src/helpers/localstorage';
import { useDispatch, useSelector } from 'react-redux';
import { submitDatosAcceso } from 'src/reducer/action/pago';
import { DataList } from './LoadingContentCommon';

const StepProgressBarCommon = ({
    loading,
    steps,
    addpropscomponent,
    stepStorage = 0 }) => {

    const dispatch = useDispatch();
    const completado = useSelector(state => state.ui.completado);

    const { stepForward, stepBackwards } = useStepProgress({
        steps,
        startingStep: (completado === 'S' || completado === 'E' || completado === 'R') ? 3 : parseFloat(stepStorage)
    });
    const stepForwardWithStorage = (step) => {

        let stepNext = step + 1;

        // state
        dispatch(submitDatosAcceso({
            idaccion: 1,// actualizacion de step
            paso: stepNext,
        }));

        // localstorage
        setItemStepz({ step: stepNext })
        return stepForward();
    }

    const stepBackwardsWithStorage = (step) => {
        let stepBack = step - 1;

        // state
        dispatch(submitDatosAcceso({
            idaccion: 1,// actualizacion de step
            paso: stepBack,
        }));

        // localstorage
        setItemStepz({ step: stepBack })
        return stepBackwards();
    }

    return (
        <React.Fragment>
            <StepProgressBar
                className='step-progress-bar'
                stepClass='step'
                steps={steps}
            />
            {
                !loading
                    ? (
                        <>
                            {
                                steps.map(({ component }, index) => (
                                    <Step step={index} key={index}>
                                        {React.cloneElement(component, { step: index, stepForward: stepForwardWithStorage, stepBackwards: stepBackwardsWithStorage, ...addpropscomponent })}
                                    </Step>

                                ))
                            }
                        </>
                    )
                    : (<h5 className='text-center'>
                        <DataList/>
                    </h5>)
            }

        </React.Fragment>
    )
}

export default StepProgressBarCommon;

StepProgressBarCommon.propTypes = {
    steps: PropTypes.array,
    addpropscomponent: PropTypes.object
}

StepProgressBarCommon.defaultProps = {
    steps: [],
    addpropscomponent: {}
}